<template>
  <div class="d-flex flex-column gap-2">
    <slot name="title">
      <title-node v-bind="computedTitle" />
    </slot>

    <div class="pl-4">
      <form-node v-if="!!content" v-bind="content" />
      <slot v-else />
    </div>
  </div>
</template>

<script>
import { PropsDefinition, Computed } from '@/_typedefs'
import { FormNodeProps } from '../FormNode.vue'
import { Question } from './QuestionNode.vue'
import TitleNode, { TitleProps } from '../Title/TitleNode.vue'
import { createNamespacedHelpers } from 'vuex'

const { mapActions: newAttendanceFormActions } = createNamespacedHelpers('newAttendanceForm')

/**
 * @typedef {Object} ParentQuestionNodeProps
 * @property {TitleProps} titleProps
 * @property {string} questionKey
 * @property {FormNodeProps} content
 */

export default {
  components: { TitleNode },
  /** @type {PropsDefinition<ParentQuestionNodeProps>} */
  props: {
    titleProps: {
      type: Object,
      default: () => ({}),
    },
    questionKey: {
      type: String,
      default: '',
    },
    content: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      /** @type {Question | null} */
      question: null,
    }
  },
  computed: {
    /** @type {Computed<TitleProps>} */
    computedTitle() {
      return {
        text: this.question?.title,
        small: true,
        ...this.titleProps,
      }
    },
  },
  methods: {
    ...newAttendanceFormActions(['getQuestion']),
  },
  async created() {
    this.question = await this.getQuestion(this.questionKey)
  },
}
</script>

<style></style>
